<template>
    <div>
        <div class="gl_title_bar marginBottom10">
            <div class="gl_tb_left">
                <span class="normaltitle">{{ storeName }}培训管理平台</span>
            </div>
        </div>
        <div class="toptitle">
            项目管理
        </div>
        <div class="top2">
            <span>项目列表</span>
            <div @click="toAdd" v-show="isCourse">新建项目</div>
        </div>
        <div class="listbox">
            <table>
                <thead>
                    <tr>
                        <th>项目名称</th>
                        <th>课程管理</th>
                        <!-- <th>学员上限</th> -->
                        <th>是否为学分项目</th>
                        <th>培训时间</th>
                        <th>项目分类</th>
                        <th>是否上架</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in storeList" :key="index">
                        <td>{{ item.proname }}</td>
                        <td style="color:#0B8586;cursor:pointer" @click="todetail(item.id, item.p_type)">查看</td>
                        <!-- <td>{{item.psum}}</td> -->
                        <td>
                            <span v-show="item.isCredit"
                                >是<span v-show="item.creditContent">，{{ item.creditContent }}</span></span
                            >
                            <span v-show="!item.isCredit">否</span>
                        </td>
                        <td>{{ formatTime(item.startDate, 'YYYY/MM/DD') }}-{{ formatTime(item.endDate, 'YYYY/MM/DD') }}</td>
                        <td>
                            <span v-show="item.p_type == 1">推送课程</span>
                            <span v-show="item.p_type == 2">自建课程</span>
                        </td>
                        <td>
                            <el-switch v-model="item.isStart" @change="startChange(item.isStart, item.id)" active-color="#13ce66" inactive-color="#dcdfe6"> </el-switch>
                        </td>
                        <td>
                            <span style="color:#0B8586;cursor:pointer" v-show="item.p_type == 2" @click="toupdata(item.id)">修改</span>
                            <!-- <span style="color:red;cursor:pointer"
                    v-show="item.p_type==1"
                    @click="toupdata(item.id)">设置</span> -->
                            <span v-show="item.p_type == 2">，</span>
                            <span style="color:#0B8586;cursor:pointer" @click="toPeopleList(item)">成员列表</span>
                        </td>
                    </tr>
                    <tr v-show="storeList.length < 1">
                        <td colspan="8">暂无项目信息</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <pagination :total="pageCount" :limit="pageSize" :page="pageIndex" isNum @page-change="pageChange"></pagination>
        <el-dialog title="课程资源详情" :visible.sync="isCourseDetails" class="Courselist" width="856px">
            <div class="cltop">
                <el-input placeholder="请输入课程名称" prefix-icon="el-icon-search" class="cltinput" v-model="clinput">
                    <el-button style="background: #0B8586;" slot="append" @click="SearchCourseList">搜索</el-button>
                </el-input>
                <div class="cltbtn" @click="toAddCoursePage" v-show="ptype == 2">添加</div>
            </div>
            <el-table :data="gridData" :row-class-name="tableRowClassName" border>
                <el-table-column property="id" label="课程ID" width="70"></el-table-column>
                <el-table-column property="title" label="课程名称"></el-table-column>
                <el-table-column label="上架时间" width="170">
                    <template slot-scope="scope">
                        <div class="timeBox">
                            <span
                                v-show="BianjiTimeIndex != scope.row.id"
                                style="cursor: pointer;color:#0B8586;"
                                @click="
                                    BianjiTimeIndex = scope.row.id;
                                    BianjiTime = scope.row.putawayDate;
                                "
                                >{{ scope.row.putawayDate }}</span
                            >
                            <!-- <input v-show="BianjiTimeIndex==scope.row.id"
                   class="timeInput"
                   type="text"> -->
                            <el-date-picker v-show="BianjiTimeIndex == scope.row.id" :clearable="false" v-model="BianjiTime" type="datetime" @change="totime" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="125">
                    <template slot-scope="scope">
                        <div class="CourseCaozuo">
                            <img src="../../assets/img/icon/yulan.png" style="width:16px;" v-show="scope.row.video_Type == 1" @click="toShow(scope.row)" alt="" />
                            <el-popover placement="bottom" trigger="click">
                                <img src="../../assets/img/icon/yulan.png" slot="reference" style="width:16px;" v-show="scope.row.video_Type == 2" @click="toShowList(scope.row)" alt="" />
                                <el-select v-model="showListId" v-if="showList.length > 0" size="small" @change="toShow2" placeholder="请选择">
                                    <el-option v-for="item in showList" :key="item.id" :label="item.title" :value="item.id"> </el-option>
                                </el-select>
                            </el-popover>

                            <img src="../../assets/img/organ/top.png" @click="topaixu(scope.row.id, 1)" alt="" />
                            <img src="../../assets/img/organ/bottom.png" @click="topaixu(scope.row.id, 2)" alt="" />
                            <img src="../../assets/img/organ/delete.png" alt="" v-show="ptype == 2" @click="deleteRow(scope.row.id)" />
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="fenye">
                <pagination :total="pageCount2" :limit="pageSize2" isNum :page="pageIndex2" @page-change="pageChange2"> </pagination>
            </div>
        </el-dialog>
        <el-dialog title="课程资源选择" :visible.sync="isCourseAdd" class="Courselist" width="856px">
            <div class="cltop">
                <el-input placeholder="请输入课程名称" prefix-icon="el-icon-search" class="cltinput" v-model="clinput2">
                    <el-button style="background: #0B8586;" slot="append" @click="SearchCourseList2">搜索</el-button>
                </el-input>
                <div class="cltbtn" @click="toAddCourse">确定</div>
            </div>
            <el-table :data="gridData2" :row-key="getRowKey" @selection-change="handleSelectionChange" border>
                <el-table-column type="selection" :selectable="getselectable" :reserve-selection="true" width="55"> </el-table-column>
                <el-table-column property="courseId" label="课程ID" width="100"></el-table-column>
                <el-table-column property="courseNmae" label="课程名称"></el-table-column>
                <el-table-column property="createDate" label="上传时间" width="180"></el-table-column>
            </el-table>
            <div class="fenye">
                <pagination :total="pageCount3" :limit="pageSize3" :page="pageIndex3" isNum @page-change="pageChange3"></pagination>
            </div>
        </el-dialog>
        <el-dialog title="项目成员列表" :visible.sync="isPeopleList" class="Courselist peopleList" width="856px">
            <el-table :data="PeopleList" border>
                <el-table-column property="userName" label="姓名" width="80"></el-table-column>
                <el-table-column property="mobile" width="120" label="手机号"></el-table-column>
                <el-table-column property="unit" label="单位"></el-table-column>
                <el-table-column property="createDate" label="添加时间" width="180"></el-table-column>
                <el-table-column label="操作" width="70">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="deletePeople(scope.row.userName, scope.row.userId)" type="text" size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="fenye">
                <pagination :total="pageCount4" :limit="pageSize4" isNum :page="pageIndex4" @page-change="pageChange4"></pagination>
            </div>
        </el-dialog>
        <perview :prerurl="prerurl" :show="IsPreview" :width="'856'" class="showbox" :title="previewtitle" @dialogData="closeDialog" :filetype="filetype"></perview>
    </div>
</template>

<script>
import Pagination from '../components/page/pagination.vue';
import Perview from '../../components/Preview/Preview-template.vue';
import format from '@/assets/unit/unit.js';
export default {
    name: 'project',
    components: {
        Pagination,
        Perview
    },
    data() {
        return {
            storeName: '',
            isCourse: false,
            storeList: '',
            isCourseDetails: false,
            gridData: [],
            isCourseAdd: false,
            gridData2: [],
            clinput2: '',
            courseIdStr: '',
            clinput: '',
            pageCount: 0,
            pageIndex: 1,
            pageSize: 5,
            pageCount2: 0,
            pageIndex2: 1,
            pageSize2: 8,
            pageCount3: 0,
            pageIndex3: 1,
            pageSize3: 8,
            pid: 0,
            ptype: 0,
            PeopleList: [],
            isPeopleList: false,
            pageCount4: 0,
            pageIndex4: 1,
            pageSize4: 8,
            BianjiTimeIndex: 0,
            BianjiTime: '',
            caid: 0,
            prerurl: '',
            IsPreview: false,
            previewtitle: '',
            filetype: '',
            showList: [],
            showListId: ''
        };
    },
    created() {
        this.storeName = localStorage.getItem('storeName');
        this.getIsCourse();
        this.GetMyStoreList();
    },
    methods: {
        formatTime(datatime, timeformat) {
            return format(datatime, timeformat);
        },
        pageChange(page) {
            if (page == this.pageIndex) return;
            this.pageIndex = page;
            this.GetMyStoreList();
        },
        pageChange2(page) {
            if (page == this.pageIndex2) return;
            this.pageIndex2 = page;
            this.getCourseList();
        },
        getIsCourse() {
            this.httphelper
                .get('/api/EnterProjectApi/IsEnterAddCouerseOk', {
                    id: Number(localStorage.getItem('storeId'))
                })
                .then(res => {
                    if (res.code == 200) {
                        this.isCourse = true;
                    } else {
                        this.isCourse = false;
                    }
                });
        },
        GetMyStoreList() {
            this.httphelper
                .post('/api/EnterProjectApi/GetEnterProjectPageList', {
                    id: Number(localStorage.getItem('storeId')),
                    page: this.pageIndex,
                    limit: this.pageSize
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.pageCount = res.data.totalcount;
                        this.storeList = res.data.data;
                    }
                });
        },
        getCourseList() {
            this.httphelper
                .post('/api/EnterProjectApi/GetEnterCoursePageList', {
                    proId: this.pid,
                    courseName: this.clinput,
                    page: this.pageIndex2,
                    limit: this.pageSize2
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.pageCount2 = res.data.totalcount;
                        this.gridData = res.data.data;
                    }
                });
        },
        todetail(id, type) {
            this.pid = id;
            this.ptype = type;
            this.clinput = '';
            this.caid = 0;
            this.getCourseList();
            this.isCourseDetails = true;
        },
        toAdd() {
            this.$router.push({
                name: 'usAddProject'
            });
        },
        startChange(status, id) {
            this.httphelper
                .post('/api/EnterProjectApi/EnterProjectStart', {
                    id: id,
                    status: status
                })
                .then(res => {
                    if (res.data.code == 200) {
                        if (status == true) this.$message.success('上架成功');
                        if (status == false) this.$message.success('下架成功');
                    }
                });
        },
        deleteRow(id) {
            this.httphelper
                .post('/api/EnterProjectApi/DelProjectCourse', {
                    courseId: id,
                    proId: this.pid
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.getCourseList();
                        this.$message.success('移除成功');
                    } else {
                        this.$message.error('移除失败');
                    }
                });
        },
        toAddCoursePage() {
            this.clinput2 = '';
            this.caid = 0;
            this.getCourseList2();
            this.isCourseAdd = true;
        },
        getCourseList2() {
            this.httphelper
                .post('/api/EnterProjectApi/GetOrgCoursePageList', {
                    orgId: Number(localStorage.getItem('storeId')),
                    courseName: this.clinput2,
                    proId: this.pid,
                    page: this.pageIndex3,
                    limit: this.pageSize3
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.pageCount3 = res.data.totalcount;
                        this.gridData2 = res.data.data;
                    }
                });
        },
        pageChange3(page) {
            if (page == this.pageIndex3) return;
            this.pageIndex3 = page;
            this.getCourseList2();
        },
        handleSelectionChange(val) {
            this.courseIdStr = '';
            for (let i = 0; i < val.length; i++) {
                if (this.courseIdStr == '') this.courseIdStr = val[i].courseId.toString();
                else this.courseIdStr += ',' + val[i].courseId;
            }
        },
        getselectable(row) {
            return !row.isExist;
        },
        getRowKey(row) {
            return row.id;
        },
        toAddCourse() {
            if (this.courseIdStr == '') return this.$message.error('请勾选课程后点击确定');
            this.httphelper
                .post('/api/EnterProjectApi/AddProjectCourse', {
                    proId: Number(this.pid),
                    ids: this.courseIdStr,
                    userId: Number(JSON.parse(localStorage.getItem('ResData')).id)
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.getCourseList();
                        this.$message.success('添加成功');
                    } else {
                        this.$message.error('添加失败');
                    }
                    this.isCourseAdd = false;
                });
        },
        pageChange4(page) {
            if (page == this.pageIndex4) {
                return;
            }
            this.pageIndex4 = page;
            this.getPeopleList();
        },
        getPeopleList() {
            this.httphelper
                .post('/api/EnterProjectApi/GetOrgitesuserPagelist', {
                    proId: Number(this.pid),
                    userName: '',
                    mobile: '',
                    page: Number(this.pageIndex4),
                    limit: Number(this.pageSize4)
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.pageCount4 = res.data.totalcount;
                        this.PeopleList = res.data.data;
                    }
                });
        },
        toPeopleList(data) {
            this.isPeopleList = true;
            this.pid = data.id;
            this.getPeopleList();
        },
        deletePeople(name, id) {
            this.$confirm('确定要将' + name + '移出项目吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.httphelper
                        .post('/api/EnterProjectApi/DelProgectUser', {
                            orgId: Number(this.pid),
                            userId: Number(id)
                        })
                        .then(res => {
                            if (res.data.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '移除成功!'
                                });
                                this.getPeopleList();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: '移除失败'
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消移除'
                    });
                });
        },
        toupdata(id) {
            this.$router.push({
                name: 'usUpdateProject',
                query: {
                    id: id
                }
            });
        },
        topaixu(id, type) {
            this.httphelper
                .post('/api/EnterProjectApi/UpdProgCourseSort', {
                    courseId: Number(id),
                    proId: this.pid,
                    type: Number(type)
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.caid = id;
                        this.getCourseList();
                    }
                });
        },
        totime() {
            this.httphelper
                .post('/api/EnterProjectApi/UpdProgCourseInfo', {
                    courseId: Number(this.BianjiTimeIndex),
                    proId: this.pid,
                    putawayDate: this.BianjiTime
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.BianjiTimeIndex = 0;
                        this.getCourseList();
                    }
                });
        },
        SearchCourseList2() {
            this.pageIndex3 = 1;
            this.getCourseList2();
        },
        SearchCourseList() {
            this.pageIndex2 = 1;
            this.getCourseList();
        },
        tableRowClassName({ row }) {
            if (row.id === this.caid) {
                return 'warning-row';
            } else {
                return 'no-row';
            }
        },
        toShow(res) {
            this.previewtitle = res.title;
            this.httphelper
                .get('/api/EnterProjectApi/GetCourseResurlById', {
                    cid: res.id
                })
                .then(res => {
                    if (res.code == 200) {
                        this.prerurl = res.data.resUrl;
                        if (res.data.resType == 2) this.filetype = '.mp4';
                        else if (res.data.resType == 3) this.filetype = '.mp3';
                        else if (res.data.resType == 4) this.filetype = '.pdf';
                        this.IsPreview = true;
                    }
                });
        },
        toShowList(res) {
            this.httphelper
                .get('/api/EnterProjectApi/GetCouCatalogById', {
                    cid: res.id
                })
                .then(res => {
                    if (res.code == 200) {
                        this.showListId = '';
                        this.showList = res.data;
                    }
                });
        },
        toShow2(e) {
            for (let i = 0; i < this.showList.length; i++) {
                if (this.showList[i].id == e) this.toShow(this.showList[i]);
            }
        },
        closeDialog() {
            this.IsPreview = false;
        }
    }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
    padding-left: 17px;
    margin: 30px 0 40px 0;
}
.top2 {
    height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
}
.top2 span {
    height: 18px;
    width: 120px;
    padding-left: 16px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    border-left: 2px solid #0b8586;
    line-height: 18px;
}
.top2 div {
    width: 153px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.Courselist ::v-deep .el-dialog {
    padding: 50px 59px 80px;
    min-height: 640px;
    position: relative;
}
.Courselist ::v-deep .el-dialog__title {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.Courselist ::v-deep .el-dialog__header {
    padding: 0;
}
.Courselist ::v-deep .el-dialog__body {
    padding: 0;
}
.Courselist ::v-deep .cell {
    text-align: center;
}
.Courselist ::v-deep .el-button {
    height: 21px;
    padding: 4px;
}
.Courselist ::v-deep td,
.Courselist ::v-deep th {
    padding: 8px 0 !important;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.Courselist ::v-deep th {
    background: #edfafa;
}
.Courselist ::v-deep .warning-row {
    background: #f5f7fa !important;
}
.Courselist ::v-deep .no-row:hover > td {
    background: #ffffff !important;
}
.Courselist ::v-deep .warning-row:hover > td {
    background: #f5f7fa !important;
}

.cltop {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.cltbtn {
    width: 97px;
    height: 40px;
    background: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fffefe;
    line-height: 40px;
    text-align: center;
    border-radius: 4px;
    margin-left: 10px;
    cursor: pointer;
}
.cltinput {
    flex: 1;
}
.cltinput ::v-deep .el-input__inner {
    border-color: #0b8586;
}
.cltinput ::v-deep .el-input-group__append,
.cltinput ::v-deep.el-button {
    background-color: #0b8586;
    color: #fffefe;
    border-color: #0b8586;
}
.cltinput ::v-deep.el-button {
    width: 97px;
    font-family: Microsoft YaHei;
}
.pagination_Wrap {
    margin: 0;
    margin-top: 35px;
}
.peopleList ::v-deep .el-dialog__header {
    margin-bottom: 30px;
}
.peopleList ::v-deep .el-dialog {
    min-height: 600px;
}
.fenye {
    width: 100%;
    position: absolute;
    left: 0px;
    bottom: 35px;
}
.CourseCaozuo img {
    margin: 0 5px;
    cursor: pointer;
}
.timeBox {
    width: 149px;
}
.timeBox ::v-deep .el-input__prefix {
    display: none;
}
.timeBox ::v-deep .el-input__inner {
    padding: 0 8px;
    width: 149px;
    height: 30px;
}
.showbox ::v-deep .el-dialog {
    min-height: 640px;
    padding-top: 20px;
}
</style>
